/**
 * Synthetic public-payment fixtures for Cruzeiro Life.
 *
 * Keep these fixtures separate from assets-mock-data.ts: that file belongs to
 * Yatta Flow and contains vehicle/property examples which must never leak into
 * the Cruzeiro Life customer portal.
 */
export const cruzeiroLifePaymentReceivables = [
  {
    installmentId: "cruzeiro-life-installment-1",
    agreementNumber: "CL-PLN-000184",
    agreementType: "FUNERAL_PLAN",
    assetName: "Plano Cruzeiro Vida Familiar",
    sequence: 3,
    dueDate: "2026-09-10",
    originalAmountCents: "8990",
    paidAmountCents: "0",
    status: "OVERDUE",
    daysLate: 10,
    lateFeeCents: "180",
    interestCents: "30",
    correctionCents: "0",
    updatedAmountCents: "9200",
  },
  {
    installmentId: "cruzeiro-life-installment-2",
    agreementNumber: "CL-PLN-000207",
    agreementType: "FUNERAL_PLAN",
    assetName: "Plano Cruzeiro Proteção Familiar",
    sequence: 1,
    dueDate: "2026-10-10",
    originalAmountCents: "12990",
    paidAmountCents: "0",
    status: "OPEN",
    daysLate: 0,
    lateFeeCents: "0",
    interestCents: "0",
    correctionCents: "0",
    updatedAmountCents: "12990",
  },
];
